import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageMeta from '@/hooks/usePageMeta';
import AboutHeader from './components/AboutHeader';
import BrandIntro from './components/BrandIntro';
import Mission from './components/Mission';
import Principles from './components/Principles';
import AboutContact from './components/AboutContact';

export default function About() {
  usePageMeta(
    '关于我们 - 我爱漫画网追更收藏站',
    '了解我爱漫画网的品牌故事、网站定位与发展理念。我们为漫画迷打造收藏漫画、连载更新提醒、追漫日历与进度保存的追更收藏站，尊重版权，专注体验。'
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <AboutHeader />
        <BrandIntro />
        <Mission />
        <Principles />
        <AboutContact />
      </main>
      <Footer />
    </div>
  );
}